import MarketContainer from './MarketContainer'; 

export default MarketContainer;